import { createTheme, ThemeProvider } from "@mui/material/styles";
import {
  Grid,
  Stack,
  Box,
  Typography,
  Icon,
  Chip,
  Card,
  CardMedia,
  CardContent,
  CardActionArea,
  Button,
} from "@mui/material";
import {
  BusinessCenter as BusinessCenterIcon,
  InfoIcon,
  LogoutOutlined,
  AccountCircle,
  ArrowBack,
} from "@mui/icons-material";
import { CircularProgress } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";

import axios from "axios";
import { AuthContext } from "../index";
import { GlobalDataContext } from "../index";
import getLPTheme from "../getLPTheme";
import { useContext, useEffect, useState, useRef } from "react";

import { getImageV3 } from "../utils/images";
import ItemsList from "./ItemsList";
import ItemsListV2 from "./ItemsListV2";
import ItemsListV3 from "./ItemsListV3";
import Chat from "./Chat";
import App from "./App";
import { getDay, getHourMinutes, now } from "../utils/dateTime";

import _ from "lodash";

const ChatScreen = () => {
  const [view, setView] = useState("account");
  const [servicesStatus, setServicesStatus] = useState("active");
  const [servicePicked, setServicePicked] = useState(null);
  const { onLogout, id, phoneNumber, userId, role } = useContext(AuthContext);
  const { messages, handleSendMessage, chats } = useContext(GlobalDataContext);

  const [itemDetailedPassed, setItemDetailedPassed] = useState(null);

  const [chatDetailed, setChatDetailed] = useState(null);

  return (
    <App
      withNavigation
      top={
        <Stack
          spacing={3}
          direction="row"
          sx={{
            backgroundColor: "#fcfcfc",
            boxShadow:
              "rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px",
            isolation: "isolate",
            display: "flex",
            flexGrow: 0,
            justifyContent: "center",
            alignItems: "center",
            p: 2,
          }}
        >
          <Typography>Чаты</Typography>
        </Stack>
      }
    >
      <Grid container>
        <Grid item md={3} lg={2} xs={12}>
          <Box>
            <ItemsListV3
              items={
                chats?.data?.length
                  ? chats?.data?.map((item) => (
                      <Card
                        // elevation={1}
                        // key={item.id}
                        // sx={{display: 'flex', '&:hover':  { border: '1px solid #2999ff'}, '&:focus': {outline: 'none'}}}
                        sx={{ border: "none" }}
                        onClick={() => {
                          setChatDetailed(item);
                          // handleServicePick(item);
                        }}
                      >
                        <CardActionArea
                          disableRipple
                          sx={{
                            display: "flex",
                            justifyContent: "flex-start",
                            alignItems: "flex-start",
                          }}
                          onClick={() => {
                            // handleServicePick(item)
                          }}
                        >
                          <CardMedia
                            component="img"
                            sx={{
                              width: 75,
                              height: 75,
                              p: 1,
                              borderRadius: "50%",
                              // ...(now() > item?.timeFrame?.to && {opacity: '0.5'})
                            }}
                            image={getImageV3(
                              item?.images?.map((im) => im.id)[0],
                              "50:50",
                            )}
                            alt=""
                          />
                          <CardContent
                            sx={{
                              display: "block",
                              flexGrow: 1,
                              alignSelf: "stretch",
                              borderBottom: "1px solid #e3e3e3",
                            }}
                          >
                            <Stack>
                              <Typography
                                align={"left"}
                                sx={{ color: "black" }}
                              >
                                {item?.title}
                              </Typography>
                              <Typography
                                align={"left"}
                                sx={{ fontSize: "12px", color: "gray" }}
                              >
                                {_.truncate(_.nth(messages?.data?.filter(message => message?.chatId === item?.chatId) , -1)?.text, {
                                    length: 50,
                                    separator: " "
                                })}
                              </Typography>
                            </Stack>
                          </CardContent>
                        </CardActionArea>
                      </Card>
                    ))
                  : null
              }
              itemsLoading={chats.isLoading}
              closeDetailed={() => {
                setChatDetailed(null);
              }}
              itemDetailed={
                chatDetailed ? (
                  <Box
                    sx={{
                      height: "100dvh",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <Box
                      sx={{
                        position: "fixed",
                        top: "0px",
                        left: "0px",
                        width: "100%",
                        height: "52px",
                        zIndex: 1310,
                        background:
                          "linear-gradient(to bottom, rgba(255,255,255,0.95) 0%, rgba(255,255,255,0.75) 60%, rgba(255,255,255,0) 100%)",
                        pointerEvents: "none",
                        "& > *": { pointerEvents: "auto" },
                      }}
                    >
                      <Chip
                        sx={{
                          zIndex: 1306,
                          // '&:hover': { cursor: 'pointer', backgroundColor: "#000", color: "#fff"},
                          p: "5px",
                          backgroundColor: "#eee",
                          // borderRadius: "50%",
                          position: "absolute",
                          top: "50%",
                          left: "50%",
                          transform: "translate(-50%, -50%)",
                          fontSize: "16px",
                        }}
                        label={chatDetailed?.title}
                      />
                      <Icon
                        onClick={() => setChatDetailed(null)}
                        sx={{
                          zIndex: 1507,
                          p: "5px",
                          backgroundColor: "#eee",
                          borderRadius: "50%",
                          position: "absolute",
                          top: "50%",
                          right: "10px",
                          transform: "translateY(-50%)",
                        }}
                      >
                        <ClearIcon />
                      </Icon>
                    </Box>
                    <Chat
                      specialistId={id}
                      messages={ messages?.data?.filter(message => message?.chatId === chatDetailed?.chatId) }
                      addMessage={(text, type) => {
                        handleSendMessage(chatDetailed?.chatId, text, type);
                      }}
                      sx={{ backgroundColor: "#fff" }}
                    />
                  </Box>
                ) : null
              }
            />
          </Box>
        </Grid>
      </Grid>
    </App>
  );
};

export default ChatScreen;
